// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FooterTable_wrap__GpJyG","text":"FooterTable_text__3Kt8c","link":"FooterTable_link__3iE8C","divider":"FooterTable_divider__9WLH9","left":"FooterTable_left__1r4yI"};